import React, { useEffect } from 'react';

const STRIPE_SCRIPT_SRC = 'https://js.stripe.com/v3/buy-button.js';

export const BuyMeCoffeePage: React.FC = () => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    if (document.querySelector(`script[src="${STRIPE_SCRIPT_SRC}"]`)) {
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = STRIPE_SCRIPT_SRC;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 py-16 space-y-12">
      <div className="rounded-2xl border border-border bg-surface p-8 md:p-10 shadow-sm">
        <div className="space-y-4">
          <p className="text-xs uppercase tracking-[0.2em] text-muted">Fuel the Focus</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-text">Like the app? Help keep it free.</h1>
          <p className="text-muted text-lg max-w-2xl">
            If 20 Minutes Rule helped you lock in, you can keep the grind going by buying a coffee or leaving a tip.
            Every contribution supports our personal focus timer, timeboxing tools, and productivity check-in experience,
            while keeping the app ad free.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-2xl border border-border bg-background p-6 text-center flex flex-col items-center">
            <h2 className="text-xl font-semibold text-text">Buy Me a Coffee</h2>
            <p className="mt-2 text-sm text-muted">
              A quick, friendly way to say thanks and keep the personal focus timer and 20 minute focus method alive.
            </p>
            <img src="/qr-code.png" alt="Buy Me a Coffee QR code" className="mt-5 h-36 w-36 object-contain" />
            <a
              href="https://buymeacoffee.com/theboringcat"
              target="_blank"
              rel="noreferrer"
              className="mt-5 inline-flex items-center justify-center rounded-md border border-primary bg-transparent px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary/10"
            >
              Open Buy Me a Coffee
            </a>
          </div>

          <div className="rounded-2xl border border-border bg-background p-6 text-center flex flex-col items-center">
            <h2 className="text-xl font-semibold text-text">Stripe Tip Jar</h2>
            <p className="mt-2 text-sm text-muted">
              Prefer Stripe? Use the secure checkout below to support this Pomodoro alternative.
            </p>
            <div className="mt-5 flex justify-center">
              <stripe-buy-button
                buy-button-id="buy_btn_1Ss9B9016eHsHZaVsmCuE0QD"
                publishable-key="pk_live_51Ss6ab016eHsHZaVsiVGfsBsiun38EiVkXZYUXgATkwMe3YurxDsznAjMMNDz5GrNhGftaCKgorKN4lEQbpIH4Ig00cld0JWVa"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-surface p-6 md:p-8">
        <h3 className="text-sm uppercase tracking-[0.2em] text-muted">Mini About</h3>
        <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-center">
          <div className="h-14 w-14 rounded-full bg-white border border-border flex items-center justify-center overflow-hidden">
            <img src="/the-boring-cat-logo.png" alt="The Boring Cat" className="h-10 w-10 object-contain" />
          </div>
          <div>
            <p className="text-lg font-semibold text-text">The Boring Cat</p>
            <p className="text-sm text-muted">
              We build calm, focused tools for people who want to work with intention.
            </p>
            <a
              href="https://theboringcat.com"
              target="_blank"
              rel="noreferrer"
              className="mt-3 inline-flex items-center justify-center rounded-md border border-primary bg-transparent px-3 py-1.5 text-sm font-semibold text-primary transition-colors hover:bg-primary/10"
            >
              Visit theboringcat.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
